exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".component-content.text-field textarea{width:100%;height:200px;resize:none;flex-grow:1;border-radius:3px;border:1px solid #c2c2c2;padding:5px;line-height:1.2em}", ""]);

